import { Box, Button, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const PageNotFound = () => {
	const navigate = useNavigate()
	return (
		<Stack width='100%' height='100vh' direction='column' justifyContent='center' alignItems='center'>
			<Box component='h1'>404 - Page not found</Box>
			<Button sx={{ mt: 2 }} variant='contained' onClick={() => navigate('/dashboard')}>
				Home
			</Button>
		</Stack>
	)
}

export default PageNotFound
